import { useParams } from "react-router-dom";

export const useSettingsPageParams = () => {
  const { siteSlug = "" } = useParams();

  return { siteSlug };
};
